import dateFormat from 'dateformat'

const formatters = {
  float: function (val) {
    return parseFloat(val).toFixed(3)
  },
  int: function (val) {
    return parseInt(val, 10)
  },
  date: function (val) {
    try {
      return dateFormat(val, 'yyyy/mm/dd')
    } catch (e) {
      console.warn(e, val)
      return ''
    }
  }
}

var formatValue = function (value, type) {
  if (typeof (type) === 'undefined') {
    return value
  }

  var formatter = formatters[type]
  if (typeof (formatter) === 'undefined') {
    return value
  }

  return formatter(value)
}

export default formatValue



//////////////////
// WEBPACK FOOTER
// ./~/ansergy-datatable/lib/format-value.js
// module id = 80
// module chunks = 0